import IUseTournament from 'hooks/tournament/use-tournament/IUseTournament';
import useTournament from 'hooks/tournament/use-tournament/useTournament';
import React from 'react';
import IInjectedNextTournament from './IInjectedNextTournament';
import TournamentViewModel from 'view-model/Tournament/TournamentViewModel/TournamentViewModel';

const withNextTournament = <ExtraProps,>(ChildComponent: React.ComponentType<ExtraProps & IInjectedNextTournament>): React.MemoExoticComponent<React.FC<ExtraProps>> => {
    const ParentComponent: React.FC<ExtraProps> = (args: ExtraProps) => {
        const { nextTournament, fetchNextTournament }: IUseTournament = useTournament();
        const tournamentVM: TournamentViewModel = React.useMemo(() => {
            return nextTournament ?? new TournamentViewModel({});
        }, [nextTournament]);

        React.useEffect(() => {
            if (!nextTournament)
                fetchNextTournament();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [nextTournament]);

        return <ChildComponent  {...args as ExtraProps} nextTournament={tournamentVM} />
    }

    return React.memo<React.FC<ExtraProps>>(ParentComponent);
};

export default withNextTournament;